import { render, staticRenderFns } from "./LeaveWallchartGrid.vue?vue&type=template&id=bd07a9c0&scoped=true"
import script from "./LeaveWallchartGrid.vue?vue&type=script&lang=js"
export * from "./LeaveWallchartGrid.vue?vue&type=script&lang=js"
import style0 from "./LeaveWallchartGrid.vue?vue&type=style&index=0&id=bd07a9c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd07a9c0",
  null
  
)

export default component.exports